import { render, staticRenderFns } from "./UIElementPreview.vue?vue&type=template&id=1ba08a98"
import script from "./UIElementPreview.vue?vue&type=script&lang=ts"
export * from "./UIElementPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports